import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'AddCompanyToPortfolioDialog',
  props: {
    width: { default: '700px' }
  },
  emits: ["company-created"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'company-created'): void
}), expose: any, slots: any, attrs: any }) {

const dialogOpen = ref(false)
const cardKey = ref(0)

watch(dialogOpen, (open) => {
  if (!open) {
    cardKey.value++
  }
})





function onCompanyCreated() {
  emit('company-created')
}

return { __sfc: true,dialogOpen, cardKey, emit, onCompanyCreated }
}

})